const colors = {
  background: '#DCDCDC',
  backgroundHeader: '#FFF',
  primary: '#069',
};

export default colors;
